import * as React from 'react';

import {LockRegularIcon} from '../icon/svg/lock-regular-icon';
import {LimitedGroup} from '../limited-group/limited-group';
import {LinkedEntity} from '../linked-entity/linked-entity';
import {LinkedLeadEntity} from '../linked-entity/linked-lead-entity';
import {getParticipantsDisplay} from '../utils/activity-helpers';

import styles from './activity-item.module.css';

type Props = {
    userId: string;
    activity: {
        id: string;
        type: string;
        name: string;
        htmlUrl: string;
        startTime: number;
        endTime: number;
        isLogged: boolean;
        isAllDay: boolean;
        isOverdue: boolean;
        isFlagged?: boolean;
        agenda: string;
        participants: any[];
        isPrivate?: boolean;
    };
    maxParticipantsDisplayed: number;
    hasActions: boolean;
};

export class ActivityItem extends React.PureComponent<Props> {
    static defaultProps = {
        maxParticipantsDisplayed: 5,
    };

    render() {
        const {activity, userId} = this.props;
        const {shownParticipants} = getParticipantsDisplay(activity.participants, userId);

        const linkedParticipants = shownParticipants
            .filter(
                (participant) =>
                    participant.type !== 'leads' &&
                    participant.type !== 'users' &&
                    participant.type !== 'teams'
            )
            .map((participant) => (
                <div key={participant.id} className={styles.participant}>
                    <LinkedEntity
                        {...participant}
                        url={participant.htmlUrl}
                        useEntityColor={false}
                        stopPropagation={true}
                    />
                </div>
            ));

        const leads = shownParticipants.filter((participant) => participant.type === 'leads');
        const users = shownParticipants
            .filter((participant) => participant.type === 'users' || participant.type === 'teams')
            .map((user) => (
                <div key={user.id} className={styles.participant}>
                    <LinkedEntity
                        {...user}
                        url={user.htmlUrl}
                        stopPropagation={true}
                        useEntityColor={false}
                    />
                </div>
            ));

        return (
            <div className={styles.container}>
                <div className='flex align-center gap-2 full-width'>
                    {/* @ts-expect-error */}
                    {activity.isPrivate === '1' &&
                        NutClientConfig.hasActivitySyncContactCreationFF && (
                            <span data-tip='This activity is private' className='flex align-center'>
                                <LockRegularIcon size={14} wrapWithDiv={false} />
                            </span>
                        )}
                    <div title={activity.name} className={styles.name}>
                        {activity.name}
                    </div>
                </div>
                <div className={styles['participants-container']}>
                    {
                        // Check that lead has htmlUrl, otherwise this component will crash the app
                        leads.length && leads[0].htmlUrl ? (
                            <div className={styles['participants-row']}>
                                <div
                                    style={{
                                        fontWeight: 500,
                                    }}
                                    className={styles.participant}
                                >
                                    <LinkedLeadEntity lead={leads[0]} showIcon={true} />
                                </div>
                            </div>
                        ) : null
                    }

                    <div className={styles['participants-row']}>
                        <LimitedGroup
                            models={linkedParticipants}
                            isHoverable={true}
                            includeMoreWord={true}
                            numDisplayed={this.props.maxParticipantsDisplayed}
                        />
                    </div>
                    {users.length ? (
                        <div className={styles['participants-row']}>
                            <LimitedGroup
                                models={users}
                                isHoverable={false}
                                includeMoreWord={true}
                                numDisplayed={1}
                            />
                        </div>
                    ) : null}
                </div>
            </div>
        );
    }
}
